import React from 'react';
import moment from 'moment';

import BaseComponent from 'src/components/BaseComponent';
import { DoctorProfileCard } from 'src/components/complex';

import { dateOfWeek, lang, permissions } from 'src/helpers';

import { STEPS } from './constants';
import { MCButton } from 'src/components/basic';
import constants from 'src/constants';
import LANG_CONST from 'src/helpers/lang/const';

export class BookOffice extends BaseComponent {
  get model() {
    return this.props.model;
  }

  get config() {
    return this.props.config;
  }

  componentDidMount() {
    this.model.subscribe(this.subscription);
  }

  componentWillUnmount() {
    this.model.unsubscribe(this.subscription);
  }

  add = (event) => {
    event.preventDefault();
    this.model.createAppointment((err, res, success) => {
      let invoiceId = res?.invoice?.id;
      if (success) {
        if (
          this.config.payNowEnabled &&
          this.model.state.payLifeapp &&
          this.model.state.payNow &&
          invoiceId
        ) {
          setTimeout(() => this.navigate('/invoices/payment/' + invoiceId), 0);
        } else {
          if (this.props.onDone) this.props.onDone();
          else this.navigate(permissions.PAGES.APPOINTMENTS_PAGE.path);
        }
      } else if (err === 'DEACTIVATED_DOCTOR') {
        this.model.checkDisabledDoctor({
          ...model.state.doctor,
          status: constants.general.userStatus.disabled
        });
        this.props.onBack();
      } else if (err === 'DEACTIVATED_ACCOUNT') {
        this.model.emit('checkDisabledAccount', this.model.state.user);
        this.props.onBack();
      }
    });
  };

  render = () => {
    const slot = this.model.state.selectedSlot;
    const { doctor } = this.model.getState();
    const { loading } = this.model.getApiState('createAppointmentOffice');

    return (
      <div
        className={
          'mc-tab-content ' + (this.model.state.step === STEPS.OFFICE ? '' : 'mc-inactive')
        }
      >
        {slot && (
          <div className={'mc-flex-20 mc-grow'} style={{ overflow: 'auto' }}>
            <div className={'mc-container-content__body-left mc-flex-20-col'}>
              <DoctorProfileCard doctor={doctor} />
            </div>
            <div className={'mc-container-content__body-center'}>
              <div className={'mc-flex-col mc-b2b mc-pb20'}>
                {slot?.hospital?.split('\n').map((txt, i) => (
                  <div className={i === 0 ? ' mc-note-2' : ''} key={i}>
                    {i === 0 ? txt.split('_')[0] : txt}
                  </div>
                ))}
              </div>
              <div className={'mc-flex-15-col mc-flex-center mc-p50'}>
                <div className={'mc-value-420'}>
                  {lang.t('To make appointment to ')}
                  <span className={'mc-value-520'}>
                    {slot?.hospital?.split('\n')[0].split('_')[0]}
                  </span>
                </div>
                <MCButton
                  label={LANG_CONST.buttons.make_appointment}
                  disabled={loading}
                  loading={loading}
                  primary
                  large
                  radius
                  dark
                  onClick={this.add}
                />
              </div>
              <div className={'mc-flex-20-col'}>
                <div className={'mc-note'}>
                  <span className={'mc-value-522'}>{lang.t('Opening times')}</span>
                </div>
                {dateOfWeek.map((date, i) => {
                  const { schedule = {} } = this.model.state.hospital || {};
                  const scheduleOfDate = schedule ? schedule[date.toLowerCase()] : {};
                  const startTime = scheduleOfDate?.times && scheduleOfDate.times[0]?.startTime;
                  const endTime =
                    scheduleOfDate?.times &&
                    scheduleOfDate.times.reverse().find((i) => !!i.endTime)?.endTime;
                  return (
                    <div className={'mc-flex'} key={i}>
                      <div className={'mc-grow mc-value-520'}>{lang.t(date)}</div>
                      {!scheduleOfDate?.isOpen || (!startTime && !endTime) ? (
                        <div className={'mc-danger-420'}>{lang.t('Closed')}</div>
                      ) : (
                        <div className={'mc-label-420'}>
                          {(startTime ? moment(startTime).format('hh:mm') : '') +
                            ' - ' +
                            (endTime ? moment(endTime).format('HH:mm') : '')}
                        </div>
                      )}
                    </div>
                  );
                })}
              </div>
            </div>
          </div>
        )}
      </div>
    );
  };
}
